import React, { useRef, useState } from "react";
import { Play } from "lucide-react";

export const PromoVideo = ({ src, poster, index }) => {
  const ref = useRef(null);
  const [started, setStarted] = useState(false);

  const start = () => {
    setStarted(true);
    ref.current?.play().catch(() => {});
  };

  return (
    <div data-testid={`app-video-${index}`} className="relative rounded-3xl overflow-hidden shadow-xl shadow-afwn-navy/10 bg-black aspect-video border border-afwn-navy/5">
      <video ref={ref} src={src} poster={poster} controls={started} playsInline preload="none" onPlay={() => setStarted(true)} className="w-full h-full object-cover">
        Your browser does not support video.
      </video>
      {!started && (
        <button type="button" onClick={start} aria-label="Play video" data-testid={`app-video-play-${index}`}
          className="group absolute inset-0 flex items-center justify-center bg-afwn-navy/10 hover:bg-afwn-navy/20 transition-colors duration-300">
          <span className="w-16 h-16 rounded-full bg-white/95 text-afwn-green shadow-lg flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
            <Play size={26} className="ml-1 fill-current" />
          </span>
        </button>
      )}
    </div>
  );
};
